import { useBreadcrumb } from "features/breadcrumbs";

import ContentConta from "components/Features/Financeiro/ContentConta";
import { useContaStore } from "features/conta/store";
import { OperacaoEnum } from "core/resources/enums/conta";
import { useEffect } from "react";

function ReceberListagemPage() {
  const { update, reset } = useContaStore();

  useEffect(() => {
    update("operacao", OperacaoEnum.Receita);
  }, [update]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Receitas" },
    { name: "Contas a receber" },
  ]);

  return (
    <>
      <ContentConta />
    </>
  );
}

export default ReceberListagemPage;
